import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/Latestlogo.png';
import Loader from "../components/Loader/Loader";
import apiRequester from '../utils/apiClient';
import { saveUserPermissions } from '../utils/permissions';

function Login() {
    const navigate = useNavigate();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleLogin = async () => {
        try {
            setLoading(true);
            setError('');

            // Display the base URL in an alert

            const response = await apiRequester('POST', 'Login/Login', {
                userName: username,
                password: password,
            });

            const token = response?.bearerJwtToken || response?.data?.bearerJwtToken || response?.token || response?.accessToken;

            if (token) {
                localStorage.setItem('authToken', token);
                saveUserPermissions(response);
            } else {
                console.warn('Login response did not include a JWT token', response);
            }

            navigate('/number');
        } catch (err) {
            setError(
                err.response?.data?.message ||
                'Invalid username or password'
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4 py-8">
            {loading && <Loader />}
            <div className="w-full max-w-sm rounded-[2rem] bg-white/95 p-8 shadow-[0_25px_50px_-20px_rgba(0,0,0,0.25)] backdrop-blur-xl">
                <div className="flex justify-center">
                    <div className="flex h-30 w-60  p-3 text-slate-900">
                        <img src={logo} alt="MIM" className="h-full w-full object-contain" />
                    </div>
                </div>

                <h1 className="mt-6 text-center text-2xl font-semibold uppercase tracking-[0.2em] text-slate-700">
                    Hyundai Monitoring
                </h1>

                <div className="mt-10 space-y-5">
                    <label className="block">
                        <span className="text-sm font-medium text-slate-600">
                            Username
                        </span>
                        <input
                            type="text"
                            placeholder="Enter username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="mt-2 w-full rounded-3xl border border-slate-200 bg-slate-50 px-4 py-3 text-slate-700 outline-none transition focus:border-cyan-400 focus:ring-2 focus:ring-cyan-100"
                        />
                    </label>

                    <label className="block">
                        <span className="text-sm font-medium text-slate-600">
                            Password
                        </span>
                        <input
                            type="password"
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="mt-2 w-full rounded-3xl border border-slate-200 bg-slate-50 px-4 py-3 text-slate-700 outline-none transition focus:border-cyan-400 focus:ring-2 focus:ring-cyan-100"
                        />
                    </label>

                    {error && (
                        <div className="text-sm text-red-600">
                            {error}
                        </div>
                    )}
                </div>

                <button
                    type="button"
                    onClick={handleLogin}
                    disabled={loading}
                    className="mt-8 w-full rounded-3xl bg-cyan-600 px-4 py-3 text-base font-semibold text-white transition hover:bg-cyan-700 disabled:opacity-50"
                >
                    {loading ? 'Logging In...' : 'Login'}
                </button>

                <span className="mt-6 block text-center text-sm text-slate-500">
                    Powered By MyInboxMedia
                </span>
            </div>
        </div>
    );
}

export default Login;
